import _ from 'lodash';
import Service from './abstract';

class FraudControl extends Service {
    constructor () {
        super('accounts');
    }

    getFraudRulesByAccountId (accountId, options = {}) {
        return this.get({
            url: `${this.basePath}/accounts/${accountId}/fraudcontrol/rules`,
            qs: _.defaultsDeep({}, options, {
                with: 'rule'
            })
        });
    }
}

export default new FraudControl();
